import axios from "axios";
import router from "@/router";

const api = axios.create({
    // baseURL: "http://127.0.0.1:8000/",
    // baseURL: "https://cotadental2.ddns.net/",

    baseURL: process.env.NODE_ENV === "development" ? "http://127.0.0.1:8000/" : "https://macrolub.ddns.net/",
    // baseURL: process.env.NODE_ENV === "development" ? "http://192.168.0.133:8000/" : "https://macrolub.ddns.net/",

    // PARA ALTERAR A URL DE PRODUÇÃO ENTRAR NO ARQUIVO .env.production

    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": "true",
        "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept, Authorization",

        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        // 'Authorization': `Bearer 6|ONqlo215CHCtZbiSsyicPzhaPCow48ZcuKCVYgZp`
        // 'Authorization': `Bearer ` + localStorage.getItem("token"),
    },
    // Set withCredentials to false for token-based authentication
    withCredentials: false,
});

api.interceptors.request.use(
    (config) => {
        // console.log('interceptor login______000')
        let token;
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
            const user = JSON.parse(sessionStorage.getItem("authUser"))
            token = user['stsTokenManager']['accessToken']
        } else {
            try {
                const user = JSON.parse(localStorage.getItem("user"));
                if (user && user['token']) {
                    token = user['token'];
                }
            } catch (error) {
                console.error("Error parsing user from localStorage:", error);
            }
        }

        // console.log('Token being sent:', token)
        if (token) {
            if (token.startsWith('Bearer ')) {
                token = token.substring(7);
            }
            config.headers.Authorization = `Bearer ${token}`
            // console.log('Authorization header set:', config.headers.Authorization)

            // Add additional debugging
            // console.log('Full request config:', {
            //     url: config.url,
            //     method: config.method,
            //     headers: config.headers,
            //     baseURL: config.baseURL
            // })
        }
        return config
    },
    (error) => {
        // console.log('rejeicao de loginxxxxx111')
        return Promise.reject(error)
    }
);

api.interceptors.response.use(
    response => response,
    (error) => {
        console.log('API Response Error:', error)

        if (error.response) {
            console.log('Response Status:', error.response.status)
            // console.log('Response Headers:', error.response.headers)
            // console.log('Response Data:', error.response.data)

            if (error.response.status === 401) {
                // console.log('Authentication error - 401 Unauthorized')
                localStorage.removeItem('user')
                localStorage.removeItem('emprconf')
                localStorage.removeItem('empratu')
                localStorage.removeItem('preferencias')

                router.push({ name: 'login'})
            }
        } else if (error.request) {
            console.log('Request made but no response received:', error.request)
        } else {
            console.log('Error setting up request:', error.message)
        }

        return Promise.reject(error)
    }
);


export default api;
